import React from "react";
import OpcionDefecto from "../../../../../Common/Components/OpcionDefecto";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";

const SegmentoCartera = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_ATLAS_SEGMENTO_CARTERA } = data;
    const arrayAux = GET_ATLAS_SEGMENTO_CARTERA.filter(d => d.Checked);

    return (
        <div className="row top-separator-xxs">
            <div className="col-xs-12 top-separator-xxs">
                <label className="label-primary">{"Segmento de Cartera"}</label>
            </div>
            <div className="col-xs-12">
                <CheckDefecto
                    nombre={"Asociar a Segmento de Cartera"}
                    check={data.AsociaSegmentoCartera}
                    referencia={"ASOSEGCAR"}
                    selectCheckBox={(event) => selectCheckBox("AsociaSegmentoCartera", event.target.checked)}
                />
            </div>
            {data.AsociaSegmentoCartera && <div className="col-xs-12 left-separator-xs top-separator-xxs">
                {GET_ATLAS_SEGMENTO_CARTERA.map( ( item ) => {
                    const referencia = `GSC-${item.Id}`;

                    return (
                        <CheckDefecto
                            key={item.Id}
                            nombre={item.Descripcion}
                            check={item.Checked}
                            activo={item.Activo}
                            referencia={referencia}
                            selectCheckBox={() => {
                                if ( data.AsociaSegmentoCartera ) {
                                    selectCheckBox( "GET_ATLAS_SEGMENTO_CARTERA", item.Id );
                                }
                            }}
                        />
                    )
                } )}
            </div>}
            <div className="col-xs-12">
            {data.AsociaSegmentoCartera &&<OpcionDefecto
                    infoData={arrayAux}
                    referencia={"SegmentoCarteraDefaultId"}
                    valorCombo={data.SegmentoCarteraDefaultId}
                    valorChecked={data.SegmentoCarteraDefaultInterfaz}
                    selecciono={arrayAux.length}
                    selectCombo={(value) => selectCombo("SegmentoCarteraDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("SegmentoCarteraDefaultInterfaz", value)}
                />}

                {(data.ERROR_PRODUCT["seleccionoSegmentoCartera"] == false && arrayAux.length<1)
                    && <label className="error">{"Debe seleccionar al menos un segmento de cartera."}</label>}
            </div>
        </div>
    );
}

export default SegmentoCartera;